import type { FC } from 'react';
import {
  type LoaderFunctionArgs,
  Navigate,
  redirect,
  useLocation,
} from 'react-router';

const trailingSlashRegex = /^(.+?)\/+(?=\?|$)/;

export const globalLoader = ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  if (url.pathname.match(trailingSlashRegex)) {
    url.pathname = url.pathname.replace(trailingSlashRegex, '$1');
    return redirect(url.toString(), 301);
  }

  return null;
};

type NavigateWithSearchProps = {
  to: string;
  replace?: boolean;
};

/**
 * 現在の URL の search (クエリ文字列) を維持したまま遷移先パスへリダイレクトする <Navigate> ラッパー。
 * リダイレクトで `fiscalYear` 等のフィルタ条件を落とさないために使用する。
 */
export const NavigateWithSearch: FC<NavigateWithSearchProps> = ({
  to,
  replace,
}) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace={replace} />;
};
